export default __webpack_public_path__ + "static/media/Áreas de Concentração e Linhas de Pesquisa Doutorado e Plano Curricular.add28014.pdf";